import React, { PureComponent, Suspense, memo } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Col, Row } from 'react-styled-flexboxgrid';
import { Eye } from 'styled-icons/fa-solid/Eye';
import { EyeSlash } from 'styled-icons/fa-solid/EyeSlash';
import { TransitionGroup, Transition } from 'react-transition-group';
import { Close } from 'styled-icons/material/Close';
import { CircleNotch } from 'styled-icons/fa-solid/CircleNotch';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof2(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof2 = function _typeof2(obj) {
      return typeof obj;
    };
  } else {
    _typeof2 = function _typeof2(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof2(obj);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FONT = {
  FAMILY: "'Untitled Sans Regular', sans-serif !important;"
};

var _templateObject;

function getLineHeight(_ref) {
  var size = _ref.size,
      precise = _ref.precise,
      _ref$theme = _ref.theme,
      SIZES = _ref$theme.FONT.SIZES,
      PADDING = _ref$theme.TEXT.PADDING;

  if (precise) {
    return 1;
  }

  return "".concat((SIZES[size] || SIZES.normal) + PADDING * 2, "px");
}

var Text = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-align: ", ";\n  font-style: ", ";\n"])), function (_ref2) {
  var display = _ref2.display;
  return display || 'block';
}, FONT.FAMILY, function (_ref3) {
  var size = _ref3.size,
      SIZES = _ref3.theme.FONT.SIZES;
  return "".concat(SIZES[size] || SIZES.normal, "px");
}, function (props) {
  return getLineHeight(props);
}, function (_ref4) {
  var weight = _ref4.weight,
      WEIGHTS = _ref4.theme.FONT.WEIGHTS;
  return WEIGHTS[weight] || WEIGHTS.normal;
}, function (_ref5) {
  var color = _ref5.color,
      type = _ref5.type,
      COLORS = _ref5.theme.TEXT.COLORS;
  return color || COLORS[type] || COLORS.normal;
}, function (_ref6) {
  var align = _ref6.align;
  return align || 'left';
}, function (_ref7) {
  var italic = _ref7.italic;
  return italic ? 'italic' : 'normal';
});
Text.displayName = 'Text';

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getButtonHeight = function getButtonHeight(_ref) {
  var compact = _ref.compact,
      HEIGHTS = _ref.theme.BUTTON.HEIGHTS;

  if (compact) {
    return HEIGHTS.compact;
  }

  return HEIGHTS.normal;
};

var getSpinnerHeight = function getSpinnerHeight(_ref2) {
  var compact = _ref2.compact,
      SPINNERS = _ref2.theme.BUTTON.SPINNERS;

  if (compact) {
    return SPINNERS.compact;
  }

  return SPINNERS.normal;
};

var getBorder = function getBorder(_ref3) {
  var renderAs = _ref3.renderAs,
      BUTTONS = _ref3.theme.BUTTONS;
  var pusedo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return BUTTONS[renderAs]["border".concat(pusedo)] || BUTTONS[renderAs].border;
};

var getBackground = function getBackground(_ref4) {
  var renderAs = _ref4.renderAs,
      BUTTONS = _ref4.theme.BUTTONS;
  var pusedo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return BUTTONS[renderAs]["background".concat(pusedo)] || BUTTONS[renderAs].background;
};

var getTextColor = function getTextColor(_ref5) {
  var renderAs = _ref5.renderAs,
      BUTTONS = _ref5.theme.BUTTONS;
  var pusedo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return BUTTONS[renderAs]["color".concat(pusedo)] || BUTTONS[renderAs].color;
};

var rotate = keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Label = styled(Text)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: ", ";\n  ", ";\n"])), function (props) {
  return getTextColor(props);
}, function (_ref6) {
  var underline = _ref6.underline;
  return underline ? 'underline' : 'none';
}, function (_ref7) {
  var busy = _ref7.busy;
  return busy && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      transform: translateX(-12px);\n    "])));
});
var StyledButton = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  cursor: pointer;\n  outline: none;\n  transition: transform 100ms ease;\n  height: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  border: ", ";\n  background: ", ";\n\n  &:hover {\n    border: ", ";\n    background: ", ";\n    ", " {\n      color: ", ";\n    }\n  }\n\n  &:disabled {\n    cursor: auto;\n    border: ", ";\n    background: ", ";\n\n    ", " {\n      color: ", ";\n    }\n\n    .icon {\n      color: ", ";\n    }\n  }\n\n  &:enabled:active {\n    transform: translateY(1px);\n  }\n\n  ", ";\n"])), function (_ref8) {
  var justify = _ref8.justify;
  return justify;
}, function (props) {
  return "".concat(getButtonHeight(props), "px");
}, function (_ref9) {
  var PADDING = _ref9.theme.BUTTON.PADDING;
  return "0 ".concat(PADDING, "px");
}, function (_ref10) {
  var RADIUS = _ref10.theme.BUTTON.RADIUS;
  return "".concat(RADIUS, "px");
}, function (props) {
  return getBorder(props);
}, function (props) {
  return getBackground(props);
}, function (props) {
  return getBorder(props, 'Hover');
}, function (props) {
  return getBackground(props, 'Hover');
}, Label, function (props) {
  return getTextColor(props, 'Hover');
}, function (props) {
  return getBorder(props, 'Disabled');
}, function (props) {
  return getBackground(props, 'Disabled');
}, Label, function (props) {
  return getTextColor(props, 'Disabled');
}, function (props) {
  return getTextColor(props, 'Disabled');
}, function (_ref11) {
  var busy = _ref11.busy;
  return busy && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      &:after {\n        position: absolute;\n        content: '';\n        border: 2px solid #fff;\n        right: 12px;\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        border-width: 2px;\n        border-color: #fff transparent #fff #fff;\n        transition: opacity 0.3s ease-in-out;\n        animation: ", " 1s infinite;\n      }\n    "])), function (props) {
    return "".concat(getSpinnerHeight(props), "px");
  }, function (props) {
    return "".concat(getSpinnerHeight(props), "px");
  }, rotate);
});

var Button = /*#__PURE__*/function (_PureComponent) {
  _inherits(Button, _PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getIcon = function (Icon) {
      return styled(Icon)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n    margin-left: ", ";\n    color: ", ";\n  "])), function (_ref12) {
        var iconPosition = _ref12.iconPosition,
            PADDING = _ref12.theme.BUTTON.PADDING;
        return iconPosition === 'left' ? "".concat(PADDING, "px") : 0;
      }, function (_ref13) {
        var iconPosition = _ref13.iconPosition,
            PADDING = _ref13.theme.BUTTON.PADDING;
        return iconPosition === 'right' ? "".concat(PADDING, "px") : 0;
      }, function (props) {
        return getTextColor(props);
      });
    };

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          icon = _this$props.icon,
          iconPosition = _this$props.iconPosition,
          onClick = _this$props.onClick,
          other = _objectWithoutProperties(_this$props, ["label", "icon", "iconPosition", "onClick"]);

      var Icon = icon ? this.getIcon(icon) : null;
      return /*#__PURE__*/React.createElement(StyledButton, Object.assign({
        justify: icon ? 'space-between' : 'center',
        onClick: onClick
      }, other), iconPosition === 'left' && Icon && /*#__PURE__*/React.createElement(Icon, Object.assign({
        className: "icon",
        iconPosition: iconPosition,
        size: 12
      }, other)), /*#__PURE__*/React.createElement(Label, Object.assign({
        align: Icon ? 'left' : 'center',
        weight: "bold"
      }, other), label), iconPosition === 'right' && Icon && /*#__PURE__*/React.createElement(Icon, Object.assign({
        className: "icon",
        iconPosition: iconPosition,
        size: 12
      }, other)));
    }
  }]);

  return Button;
}(PureComponent);

Button.defaultProps = {
  underline: false,
  renderAs: 'primary',
  icon: null,
  iconPosition: 'right',
  busy: false,
  onClick: function onClick() {}
};

/* eslint-disable import/prefer-default-export */

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var getGapSize = function getGapSize(_ref) {
  var gap = _ref.gap,
      LAYOUT = _ref.theme.LAYOUT;
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (typeof gap === 'boolean') {
    return "".concat(LAYOUT.GAP, "px");
  }

  return "".concat(Number.isFinite(gap) ? gap : def, "px");
};

var getGutterSize = function getGutterSize(_ref2) {
  var gutter = _ref2.gutter,
      LAYOUT = _ref2.theme.LAYOUT;
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (typeof gutter === 'boolean') {
    return "".concat(LAYOUT.GUTTER, "px");
  }

  return "".concat(Number.isFinite(gutter) ? gutter : def, "px");
};

var getPadding = function getPadding(props) {
  var gap = getGapSize(props);
  var gutter = getGutterSize(props);
  return "".concat(gap, " ").concat(gutter);
};

var FlexView = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  padding: ", ";\n  ", ";\n  ", ";\n  ", ";\n  text-align: ", ";\n"])), function (_ref3) {
  var flexDirection = _ref3.flexDirection;
  return flexDirection || 'column';
}, function (props) {
  return getPadding(props);
}, function (_ref4) {
  var inherit = _ref4.inherit;
  return inherit && css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n      height: inherit;\n    "])));
}, function (_ref5) {
  var alignItems = _ref5.alignItems;
  return alignItems && css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n      align-items: ", ";\n    "])), alignItems);
}, function (_ref6) {
  var justifyContent = _ref6.justifyContent;
  return justifyContent && css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n      justify-content: ", ";\n    "])), justifyContent);
}, function (_ref7) {
  var align = _ref7.align;
  return align;
});
var Col$1 = styled(Col)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  padding: ", ";\n  ", ";\n  ", ";\n  text-align: ", ";\n"])), function (props) {
  return "".concat(getGapSize(props), " ").concat(getGutterSize(props, props.theme.LAYOUT.GUTTER / 2));
}, function (_ref8) {
  var auto = _ref8.auto;
  return auto && css(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n      flex: 1;\n    "])));
}, function (_ref9) {
  var autoRight = _ref9.autoRight;
  return autoRight && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      margin-left: auto;\n    "])));
}, function (_ref10) {
  var align = _ref10.align;
  return align;
});
var Row$1 = styled(Row)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  flex-direction: ", ";\n  margin-right: 0;\n  margin-left: 0;\n  padding: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  text-align: ", ";\n"])), function (_ref11) {
  var reverse = _ref11.reverse;
  return reverse ? 'row-reverse' : 'row';
}, function (props) {
  return getPadding(props);
}, function (_ref12) {
  var nowrap = _ref12.nowrap;
  return nowrap && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      flex-wrap: inherit;\n      & > :first-child {\n        padding-left: 0;\n      }\n\n      & > :last-child {\n        padding-right: 0;\n      }\n    "])));
}, function (_ref13) {
  var inherit = _ref13.inherit;
  return inherit && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      height: inherit;\n    "])));
}, function (_ref14) {
  var alignItems = _ref14.alignItems;
  return alignItems && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      align-items: ", ";\n    "])), alignItems);
}, function (_ref15) {
  var justifyContent = _ref15.justifyContent;
  return justifyContent && css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      justify-content: ", ";\n    "])), justifyContent);
}, function (_ref16) {
  var align = _ref16.align;
  return align;
});
var Card = styled(FlexView)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: block;\n  background: ", ";\n  border-radius: ", ";\n  ", ";\n  overflow: hidden;\n"])), function (_ref17) {
  var background = _ref17.theme.CARD.background;
  return background;
}, function (_ref18) {
  var radius = _ref18.theme.CARD.radius;
  return "".concat(radius, "px");
}, function (_ref19) {
  var shadow = _ref19.shadow,
      CARD = _ref19.theme.CARD;
  return !shadow && shadow !== false && css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      box-shadow: ", ";\n    "])), CARD.shadow);
});

var _templateObject$3;

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var StyledInput = styled.input(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 42px;\n  line-height: 14px;\n  border: 1px solid #bac0c3;\n  border-radius: 4px;\n  outline: none;\n  font-family: ", ";\n  font-size: 14px;\n  padding: 14px;\n  margin-top: 8px;\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), FONT.FAMILY, function (_ref) {
  var COLORS = _ref.theme.COLORS;
  return COLORS.SKY_DARK;
});

var TextInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextInput, _PureComponent);

  var _super = _createSuper$1(TextInput);

  function TextInput() {
    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(e.target.value, e);
    };

    return _this;
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          error = _this$props.error,
          onChange = _this$props.onChange,
          other = _objectWithoutProperties(_this$props, ["label", "error", "onChange"]);

      return /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Row$1, null, /*#__PURE__*/React.createElement(Col$1, null, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        precise: true
      }, label)), error && /*#__PURE__*/React.createElement(Col$1, {
        autoRight: true
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        type: "negative",
        precise: true
      }, error))), /*#__PURE__*/React.createElement(StyledInput, Object.assign({
        onChange: this.onChange
      }, other)));
    }
  }]);

  return TextInput;
}(PureComponent);

TextInput.defaultProps = {
  type: 'text',
  label: null,
  placeholder: '',
  error: null,
  onChange: function onChange() {}
};

var _templateObject$4, _templateObject2$2, _templateObject3$2;

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var InputWrapper = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: 8px;\n"])));
var ToggleWrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 14px;\n  color: ", ";\n"])), function (_ref) {
  var COLORS = _ref.theme.COLORS;
  return COLORS.GRAY;
});
var StyledInput$1 = styled.input(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 42px;\n  line-height: 14px;\n  border: 1px solid #bac0c3;\n  border-radius: 4px;\n  outline: none;\n  font-family: ", ";\n  font-size: 14px;\n  padding: 14px;\n  padding-right: ", "px;\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), FONT.FAMILY, function (_ref2) {
  var toggleEnabled = _ref2.toggleEnabled;
  return toggleEnabled ? 52 : 14;
}, function (_ref3) {
  var COLORS = _ref3.theme.COLORS;
  return COLORS.SKY_DARK;
});

var PasswordInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(PasswordInput, _PureComponent);

  var _super = _createSuper$2(PasswordInput);

  function PasswordInput() {
    var _this;

    _classCallCheck(this, PasswordInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      type: 'password'
    };

    _this.onChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(e.target.value, e);
    };

    _this.toggleInputType = function () {
      _this.setState(function (_ref4) {
        var type = _ref4.type;
        return {
          type: type === 'password' ? 'text' : 'password'
        };
      });
    };

    return _this;
  }

  _createClass(PasswordInput, [{
    key: "renderEye",
    value: function renderEye() {
      var type = this.state.type;
      return /*#__PURE__*/React.createElement(ToggleWrapper, null, type === 'password' ? /*#__PURE__*/React.createElement(Eye, {
        size: 24,
        onClick: this.toggleInputType
      }) : /*#__PURE__*/React.createElement(EyeSlash, {
        size: 24,
        onClick: this.toggleInputType
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          error = _this$props.error,
          onChange = _this$props.onChange,
          toggleEnabled = _this$props.toggleEnabled,
          others = _objectWithoutProperties(_this$props, ["label", "error", "onChange", "toggleEnabled"]);

      var type = this.state.type;
      return /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Row$1, null, /*#__PURE__*/React.createElement(Col$1, null, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        precise: true
      }, label)), error && /*#__PURE__*/React.createElement(Col$1, {
        autoRight: true
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        type: "negative",
        precise: true
      }, error))), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(StyledInput$1, Object.assign({
        toggleEnabled: toggleEnabled,
        onChange: this.onChange
      }, others, {
        type: type
      })), toggleEnabled && this.renderEye()));
    }
  }]);

  return PasswordInput;
}(PureComponent);

PasswordInput.defaultProps = {
  toggleEnabled: false,
  label: null,
  placeholder: '',
  error: null,
  onChange: function onChange() {}
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Item = /*#__PURE__*/function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper$3(Item);

  function Item() {
    _classCallCheck(this, Item);

    return _super.apply(this, arguments);
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          item = _this$props.item,
          renderItem = _this$props.renderItem,
          other = _objectWithoutProperties(_this$props, ["index", "item", "renderItem"]);

      return renderItem(_objectSpread({
        item: item,
        index: index
      }, other));
    }
  }]);

  return Item;
}(PureComponent);

var List = /*#__PURE__*/function (_PureComponent2) {
  _inherits(List, _PureComponent2);

  var _super2 = _createSuper$3(List);

  function List() {
    _classCallCheck(this, List);

    return _super2.apply(this, arguments);
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          keyExtractor = _this$props2.keyExtractor,
          ItemSeparatorComponent = _this$props2.ItemSeparatorComponent,
          other = _objectWithoutProperties(_this$props2, ["data", "keyExtractor", "ItemSeparatorComponent"]);

      var list = data.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Item, Object.assign({
          key: keyExtractor(item, index),
          index: index,
          item: item
        }, other));
      });

      if (!ItemSeparatorComponent) {
        return list;
      }

      return list.reduce(function (acc, x) {
        if (acc === null) {
          return [x];
        }

        return [].concat(_toConsumableArray(acc), [/*#__PURE__*/React.createElement(ItemSeparatorComponent, {
          key: "separator-".concat(x.key)
        }), x]);
      }, null);
    }
  }]);

  return List;
}(PureComponent);

List.defaultProps = {
  keyExtractor: function keyExtractor(item) {
    return item.id;
  },
  ItemSeparatorComponent: null
};

var _templateObject$5, _templateObject2$3;

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SectionHeader = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  outline: none;\n"])));
var SectionContent = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  transition: max-height 300ms ease-in-out;\n  max-height: ", ";\n  overflow: hidden;\n"])), function (_ref) {
  var height = _ref.height;
  return height ? "".concat(height, "px") : 0;
});

var Item$1 = /*#__PURE__*/function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper$4(Item);

  function Item() {
    _classCallCheck(this, Item);

    return _super.apply(this, arguments);
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          sectionIndex = _this$props.sectionIndex,
          section = _this$props.section,
          item = _this$props.item,
          renderItem = _this$props.renderItem;
      return renderItem({
        item: item,
        section: section,
        index: index,
        sectionIndex: sectionIndex
      });
    }
  }]);

  return Item;
}(PureComponent);

var Section = /*#__PURE__*/function (_PureComponent2) {
  _inherits(Section, _PureComponent2);

  var _super2 = _createSuper$4(Section);

  function Section() {
    var _this;

    _classCallCheck(this, Section);

    _this = _super2.call(this);

    _this.onHeaderClick = function () {
      var open = _this.state.open;
      var height = 0;

      if (_this.sectionRef && !open) {
        height = _this.sectionRef.current.scrollHeight;
      }

      _this.setState({
        open: !open,
        height: height
      });
    };

    _this.handleOngoingSheets = function () {
      var section = _this.props.section;

      if (section.status === 'IN_PROGRESS') {
        _this.setState({
          open: true,
          height: _this.sectionRef.current.scrollHeight
        });
      }
    };

    _this.state = {
      height: 0,
      open: false
    };
    _this.sectionRef = React.createRef();
    return _this;
  }

  _createClass(Section, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleOngoingSheets();
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this$props2 = this.props,
          sectionIndex = _this$props2.index,
          dataKey = _this$props2.dataKey,
          section = _this$props2.section,
          itemKeyExtractor = _this$props2.itemKeyExtractor,
          other = _objectWithoutProperties(_this$props2, ["index", "dataKey", "section", "itemKeyExtractor"]);

      return section[dataKey].map(function (item, index) {
        return /*#__PURE__*/React.createElement(Item$1, Object.assign({
          key: itemKeyExtractor(item),
          index: index,
          sectionIndex: sectionIndex,
          item: item,
          section: section
        }, other));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          index = _this$props3.index,
          section = _this$props3.section,
          renderSectionHeader = _this$props3.renderSectionHeader,
          renderSectionFooter = _this$props3.renderSectionFooter;
      var _this$state = this.state,
          open = _this$state.open,
          height = _this$state.height;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionHeader, {
        onKeyPress: this.onHeaderClick,
        onClick: this.onHeaderClick,
        role: "button",
        tabIndex: 0
      }, renderSectionHeader(section, index, open)), /*#__PURE__*/React.createElement(SectionContent, {
        height: height,
        ref: this.sectionRef
      }, this.renderItems()), renderSectionFooter(section, index));
    }
  }]);

  return Section;
}(PureComponent);

Section.defaultProps = {
  itemKeyExtractor: function itemKeyExtractor(section) {
    return section.id;
  }
};

var SectionList = /*#__PURE__*/function (_PureComponent3) {
  _inherits(SectionList, _PureComponent3);

  var _super3 = _createSuper$4(SectionList);

  function SectionList() {
    _classCallCheck(this, SectionList);

    return _super3.apply(this, arguments);
  }

  _createClass(SectionList, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          data = _this$props4.data,
          sectionKeyExtractor = _this$props4.sectionKeyExtractor,
          other = _objectWithoutProperties(_this$props4, ["data", "sectionKeyExtractor"]);

      return data.map(function (section, index) {
        return /*#__PURE__*/React.createElement(Section, Object.assign({
          key: sectionKeyExtractor(section),
          index: index,
          section: section
        }, other));
      });
    }
  }]);

  return SectionList;
}(PureComponent);

SectionList.defaultProps = {
  sectionKeyExtractor: function sectionKeyExtractor(section) {
    return section.id;
  }
};

var _templateObject$6, _templateObject2$4;

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var StyledInput$2 = styled.input(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  padding: 10px;\n  transform: scale(1.5);\n"])));
var StyledCol = styled(Col$1)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  margin-top: -3px;\n  padding-left: 2px;\n"])));

var CheckBox = /*#__PURE__*/function (_PureComponent) {
  _inherits(CheckBox, _PureComponent);

  var _super = _createSuper$5(CheckBox);

  function CheckBox() {
    var _this;

    _classCallCheck(this, CheckBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          id = _this$props.id,
          value = _this$props.value;
      onChange(id, value);
    };

    return _this;
  }

  _createClass(CheckBox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          checked = _this$props2.checked;
      return /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Row$1, null, /*#__PURE__*/React.createElement(Col$1, null, /*#__PURE__*/React.createElement(StyledInput$2, {
        type: "checkbox",
        value: value,
        checked: checked,
        onChange: this.onChange
      })), /*#__PURE__*/React.createElement(StyledCol, null, /*#__PURE__*/React.createElement(Text, null, value))));
    }
  }]);

  return CheckBox;
}(PureComponent);

CheckBox.defaultProps = {
  value: '',
  checked: false
};

var _templateObject$7;
var Separator = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  height: ", ";\n  background-color: ", ";\n"])), function (_ref) {
  var height = _ref.height;
  return "".concat(height || 1, "px");
}, function (_ref2) {
  var transparent = _ref2.transparent,
      COLORS = _ref2.theme.COLORS;
  return transparent ? 'transparent' : COLORS.BORDER;
});
Separator.displayName = 'Separator';

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CheckBoxGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(CheckBoxGroup, _PureComponent);

  var _super = _createSuper$6(CheckBoxGroup);

  function CheckBoxGroup() {
    var _this;

    _classCallCheck(this, CheckBoxGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function (id, value) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          selected = _this$props.selected;
      var index = selected.map(function (i) {
        return i.id;
      }).indexOf(id);

      if (index !== -1) {
        onChange([].concat(_toConsumableArray(selected.slice(0, index)), _toConsumableArray(selected.slice(index + 1, selected.length))));
      } else {
        onChange([].concat(_toConsumableArray(selected), [{
          id: id,
          value: value
        }]));
      }
    };

    _this.renderCheckbox = function (_ref) {
      var item = _ref.item;
      var _this$props2 = _this.props,
          valueKey = _this$props2.valueKey,
          selected = _this$props2.selected;
      var id = item.id;
      return /*#__PURE__*/React.createElement(CheckBox, {
        key: id,
        id: id,
        value: item[valueKey],
        option: item,
        checked: selected.map(function (i) {
          return i.id;
        }).indexOf(id) !== -1,
        onChange: _this.onChange
      });
    };

    return _this;
  }

  _createClass(CheckBoxGroup, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          separator = _this$props3.separator,
          options = _this$props3.options,
          selected = _this$props3.selected;
      return /*#__PURE__*/React.createElement(List, {
        keyExtractor: function keyExtractor(item) {
          return item.id;
        },
        data: options,
        extraData: selected,
        renderItem: this.renderCheckbox,
        ItemSeparatorComponent: separator ? function () {
          return /*#__PURE__*/React.createElement(Separator, {
            height: 8,
            transparent: true
          });
        } : null
      });
    }
  }]);

  return CheckBoxGroup;
}(PureComponent);

CheckBoxGroup.defaultProps = {
  selected: [],
  separator: false,
  valueKey: 'value'
};

var _templateObject$8, _templateObject2$5;

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Background = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  background: ", ";\n  width: 100%;\n  height: ", ";\n  border-radius: ", ";\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var height = _ref2.height;
  return "".concat(height, "px");
}, function (_ref3) {
  var height = _ref3.height,
      corners = _ref3.corners;
  return corners ? "".concat(height / 2, "px") : 0;
});
var Progress = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  position: absolute;\n  background: ", ";\n  transition: width 300ms ease-in-out;\n  width: ", ";\n  height: 100%;\n  border-radius: ", "px;\n"])), function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, function (_ref5) {
  var progress = _ref5.progress;
  return "".concat(progress, "%");
}, function (_ref6) {
  var borderRadius = _ref6.borderRadius;
  return borderRadius || 0;
});

var ProgressBarHorizontal = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProgressBarHorizontal, _PureComponent);

  var _super = _createSuper$7(ProgressBarHorizontal);

  function ProgressBarHorizontal() {
    _classCallCheck(this, ProgressBarHorizontal);

    return _super.apply(this, arguments);
  }

  _createClass(ProgressBarHorizontal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          borderRadius = _this$props.borderRadius,
          height = _this$props.height,
          progress = _this$props.progress,
          corners = _this$props.corners,
          backgroundColor = _this$props.backgroundColor,
          progressColor = _this$props.progressColor;
      return /*#__PURE__*/React.createElement(Background, {
        height: height,
        corners: corners,
        backgroundColor: backgroundColor
      }, /*#__PURE__*/React.createElement(Progress, {
        height: height,
        progress: progress,
        backgroundColor: progressColor,
        borderRadius: borderRadius
      }));
    }
  }]);

  return ProgressBarHorizontal;
}(PureComponent);

ProgressBarHorizontal.defaultProps = {
  borderRadius: 0,
  height: 8,
  backgroundColor: '#DEEEFF',
  progressColor: 'linear-gradient(94.5deg, #0177FF 0%, #1F48D7 100%)',
  corners: true
};

var _templateObject$9, _templateObject2$6, _templateObject3$3;

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SVG = styled.svg(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  display: block;\n"])));
var Circle = styled.circle(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  transition: stroke-dashoffset 0.3s;\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n"])));
var Text$1 = styled.text(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  text-anchor: middle;\n  dominant-baseline: middle;\n  stroke-width: 0;\n  font-weight: 700;\n"])), FONT.FAMILY, function (_ref) {
  var textSize = _ref.textSize;
  return "".concat(textSize, "px");
});

var ProgressBarRadial = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProgressBarRadial, _PureComponent);

  var _super = _createSuper$8(ProgressBarRadial);

  function ProgressBarRadial() {
    _classCallCheck(this, ProgressBarRadial);

    return _super.apply(this, arguments);
  }

  _createClass(ProgressBarRadial, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          radius = _this$props.radius,
          progress = _this$props.progress,
          stroke = _this$props.stroke,
          backgroundColor = _this$props.backgroundColor,
          progressColor = _this$props.progressColor,
          fillColor = _this$props.fillColor,
          text = _this$props.text,
          textColor = _this$props.textColor,
          textSize = _this$props.textSize;
      var circumference = ProgressBarRadial.getCircumference(radius - stroke);
      return /*#__PURE__*/React.createElement(SVG, {
        width: radius * 2,
        height: radius * 2
      }, /*#__PURE__*/React.createElement(Circle, {
        cx: radius,
        cy: radius,
        r: radius - stroke,
        strokeWidth: stroke,
        fill: fillColor,
        stroke: backgroundColor
      }), /*#__PURE__*/React.createElement(Circle, {
        cx: radius,
        cy: radius,
        r: radius - stroke,
        strokeWidth: stroke,
        fill: fillColor,
        stroke: progressColor,
        strokeDasharray: "".concat(circumference, " ").concat(circumference),
        strokeDashoffset: circumference - circumference * progress * 0.01
      }), text && /*#__PURE__*/React.createElement(Text$1, {
        x: "50%",
        y: "50%",
        "text-anchor": "middle",
        stroke: textColor,
        textSize: textSize
      }, text));
    }
  }], [{
    key: "getCircumference",
    value: function getCircumference(radius) {
      return Math.PI * radius * 2;
    }
  }]);

  return ProgressBarRadial;
}(PureComponent);

ProgressBarRadial.defaultProps = {
  radius: 8,
  stroke: 2,
  backgroundColor: '#DEEEFF',
  progressColor: '#1657E4',
  fillColor: 'transparent',
  textColor: '#000000',
  textSize: 14,
  text: null
};

var _templateObject$a, _templateObject2$7, _templateObject3$4, _templateObject4$2;

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Wrapper = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  width: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return "".concat(width, "px");
});
var Gauge = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 50%;\n  overflow: hidden;\n\n  &:before {\n    position: absolute;\n    content: '';\n    height: 200%;\n    width: 100%;\n    border-radius: 50%;\n    background-color: ", ";\n    border: 1px solid #000000;\n  }\n\n  &:after {\n    position: absolute;\n    content: '';\n    height: 4px;\n    width: 4px;\n    border-radius: 50%;\n    background-color: #000000;\n    bottom: -2px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"])), function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
});
var Meter = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.3s;\n  transform-origin: center bottom;\n  transform: rotate(", "deg);\n  border: 1px solid #000000;\n  border-top-right-radius: ", ";\n  border-top-left-radius: ", ";\n  background-color: ", ";\n\n  &:after {\n    position: absolute;\n    content: '';\n    transform: rotate(45deg);\n    bottom: -2px;\n    right: -2px;\n    border: 2px solid;\n    border-bottom-color: black;\n    border-left-color: black;\n    border-top-color: transparent;\n    border-right-color: transparent;\n  }\n"])), function (_ref3) {
  var danger = _ref3.danger;
  return 180 + 180 * danger * 0.01;
}, function (_ref4) {
  var width = _ref4.width;
  return "".concat(width / 2, "px");
}, function (_ref5) {
  var width = _ref5.width;
  return "".concat(width / 2, "px");
}, function (_ref6) {
  var progressColor = _ref6.progressColor;
  return progressColor;
});
var Needle = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: calc(50% - 2px);\n  bottom: 0;\n  height: 100%;\n  transform-origin: bottom;\n  transform: rotate(", "deg);\n  transition: transform .8s ease-in-out;\n  border-left: 2px solid transparent;\n  border-right: 2px solid transparent;\n  border-bottom: 20px solid #000000;\n"])), function (_ref7) {
  var progress = _ref7.progress;
  return -90 + 180 * progress * 0.01;
});

var ProgressBarGauge = /*#__PURE__*/function (_PureComponent) {
  _inherits(ProgressBarGauge, _PureComponent);

  var _super = _createSuper$9(ProgressBarGauge);

  function ProgressBarGauge() {
    _classCallCheck(this, ProgressBarGauge);

    return _super.apply(this, arguments);
  }

  _createClass(ProgressBarGauge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          progress = _this$props.progress,
          danger = _this$props.danger,
          backgroundColor = _this$props.backgroundColor,
          progressColor = _this$props.progressColor;
      return /*#__PURE__*/React.createElement(Wrapper, {
        width: width
      }, /*#__PURE__*/React.createElement(Gauge, {
        backgroundColor: backgroundColor
      }, /*#__PURE__*/React.createElement(Meter, {
        progressColor: progressColor,
        danger: danger,
        width: width
      }), /*#__PURE__*/React.createElement(Needle, {
        progress: progress
      })));
    }
  }]);

  return ProgressBarGauge;
}(PureComponent);

ProgressBarGauge.defaultProps = {
  backgroundColor: '#2AC3AA',
  progressColor: '#EA5959'
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

var _templateObject$b, _templateObject2$8, _templateObject3$5, _templateObject4$3, _templateObject5$2, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1;

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var moveten = keyframes(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  0% {\n    top: 0;\n  }\n  100% {\n    top: -200px;\n  }\n"])));
var movesix = keyframes(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  0% {\n    top: 0;\n  }\n  100% {\n    top: -120px;\n  }\n"])));
var Wrapper$1 = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 20px;\n  width: 8px;\n  display: inline-block;\n  overflow: hidden;\n"])));
var Sec1 = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  animation: ", " 60s steps(6, end) infinite;\n  animation-delay: ", ";\n"])), movesix, function (_ref) {
  var delay = _ref.delay;
  return "-".concat(delay, "s");
});
var Sec2 = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  animation: ", " 10s steps(10, end) infinite;\n"])), moveten);
var Min1 = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  animation: ", " 3600s steps(6, end) infinite;\n  animation-delay: ", ";\n"])), movesix, function (_ref2) {
  var delay = _ref2.delay;
  return "-".concat(delay, "s");
});
var Min2 = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  animation: ", " 600s steps(10, end) infinite;\n  animation-delay: ", ";\n"])), moveten, function (_ref3) {
  var delay = _ref3.delay;
  return "-".concat(delay, "s");
});
var Hour2 = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  animation: ", " 36000s steps(10, end) infinite;\n  animation-delay: ", ";\n"])), moveten, function (_ref4) {
  var delay = _ref4.delay;
  return "-".concat(delay, "s");
});
var Hour1 = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  animation: ", " 360000s steps(10, end) infinite;\n  animation-delay: ", ";\n"])), moveten, function (_ref5) {
  var delay = _ref5.delay;
  return "-".concat(delay, "s");
});
var SplitText = styled(Text)(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  line-height: 18px;\n"])));
var TENS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
var SIXES = [0, 1, 2, 3, 4, 5];

var Clock = /*#__PURE__*/function (_PureComponent) {
  _inherits(Clock, _PureComponent);

  var _super = _createSuper$a(Clock);

  function Clock() {
    _classCallCheck(this, Clock);

    return _super.apply(this, arguments);
  }

  _createClass(Clock, [{
    key: "render",
    value: function render() {
      var startFrom = this.props.startFrom;

      var _Clock$getDigits = Clock.getDigits(startFrom),
          _Clock$getDigits2 = _slicedToArray(_Clock$getDigits, 6),
          H1 = _Clock$getDigits2[0],
          H2 = _Clock$getDigits2[1],
          M1 = _Clock$getDigits2[2],
          M2 = _Clock$getDigits2[3],
          S1 = _Clock$getDigits2[4],
          S2 = _Clock$getDigits2[5];

      var SEC2 = [].concat(_toConsumableArray(TENS.slice(S2)), _toConsumableArray(TENS.slice(0, S2)));
      var SEC1 = [].concat(_toConsumableArray(SIXES.slice(S1)), _toConsumableArray(SIXES.slice(0, S1)));
      var MIN2 = [].concat(_toConsumableArray(TENS.slice(M2)), _toConsumableArray(TENS.slice(0, M2)));
      var MIN1 = [].concat(_toConsumableArray(SIXES.slice(M1)), _toConsumableArray(SIXES.slice(0, M1)));
      var HOUR2 = [].concat(_toConsumableArray(TENS.slice(H2)), _toConsumableArray(TENS.slice(0, H2)));
      var HOUR1 = [].concat(_toConsumableArray(TENS.slice(H1)), _toConsumableArray(TENS.slice(0, H1)));
      var delayS1 = S2;
      var delayM2 = +"".concat(S1).concat(S2);
      var delayM1 = M2 * 60 + delayM2;
      var delayH2 = "".concat(M1).concat(M2) * 60 + delayM2;
      var delayH1 = H2 * 60 * 60 + delayH2;
      var FlexDiv = styled.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n      display: flex;\n    "])));
      return /*#__PURE__*/React.createElement(FlexDiv, null, /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(Hour1, {
        delay: delayH1
      }, HOUR1.map(function (v) {
        return /*#__PURE__*/React.createElement(Text, {
          size: "small",
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(Hour2, {
        delay: delayH2
      }, HOUR2.map(function (v) {
        return /*#__PURE__*/React.createElement(Text, {
          size: "small",
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(SplitText, {
        size: "small",
        align: "center",
        weight: "bold"
      }, ":")), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(Min1, {
        delay: delayM1
      }, MIN1.map(function (v) {
        return /*#__PURE__*/React.createElement(Text, {
          size: "small",
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(Min2, {
        delay: delayM2
      }, MIN2.map(function (v) {
        return /*#__PURE__*/React.createElement(Text, {
          size: "small",
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(SplitText, {
        size: "small",
        align: "center",
        weight: "bold"
      }, ":")), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(Sec1, {
        delay: delayS1
      }, SEC1.map(function (v) {
        return /*#__PURE__*/React.createElement(Text, {
          size: "small",
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(Sec2, null, SEC2.map(function (v) {
        return /*#__PURE__*/React.createElement(Text, {
          size: "small",
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))));
    }
  }], [{
    key: "getDigits",
    value: function getDigits(time) {
      if (time < 0) {
        return [0, 0, 0, 0, 0, 0];
      }

      var hours = Math.trunc(time / 3600);
      var minutes = Math.trunc(time / 60);
      var seconds = Math.trunc(time % 60);
      return [Math.trunc(hours / 10), Math.trunc(hours % 10), Math.trunc(minutes % 60 / 10), Math.trunc(minutes % 60 % 10), Math.trunc(seconds / 10), Math.trunc(seconds % 10)];
    }
  }]);

  return Clock;
}(PureComponent);

Clock.defaultProps = {
  startFrom: 0
};

var toRGB = function toRGB(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
};

var toRGBA = function toRGBA(hex, alpha) {
  var rgb = toRGB(hex);
  return rgb ? "rgba(".concat(rgb.join(', '), ", ").concat(alpha, ")") : null;
};
var COLORS_MAP = {
  ALICE_BLUE_LIGHT: '#e6f2fc',
  APPLE_2: '#149A53',
  AQUAMARINE: '#52C8F5',
  ASH_1: '#B8C6D9',
  ASH_2: '#4D515F',
  ATHENS_GRAY_1: '#e2e4eb',
  ATHENS_GRAY: '#e3e4eb',
  ATHENS_GREY: '#F7F7FA',
  BEIGE: '#fcf4e4',
  BITTERSWEET: '#DA5107',
  BLACK: '#000000',
  BRIGHT_GREEN: '#71DF96',
  BURNT_ORANGE: '#B36B00',
  BURNT_SIENNA: '#E66C43',
  BUTTERCUP: '#F5A623',
  CARNATION_PINK: '#FF98C3',
  CATALINA_BLUE: '#0B2585',
  CATSKILL_WHITE: '#E6EBF2',
  CHATEAU_GREEN: '#4CAC6A',
  CHELSEA_CUCUMBER: '#8EB355',
  CLOUD: '#F6F6F6',
  COD_GRAY: '#0B0B0B',
  COLA_LIGHTER: 'rgba(43, 43, 43, 0.75)',
  COLA: '#2B2B2B',
  CORAL: '#ff7f50',
  CORN: '#F4BF09',
  CORNSILK: '#FFF8DC',
  DARK_BLUE: '#003399',
  DARK_BLUE_2: '#01234a',
  DARK_FADED_GREY: '#757575',
  DARK_GRAY: '#7E7E7E',
  DARK_GREEN: '#459525',
  DARK_HEART: '#E85300',
  DARK_PINK: '#e75480',
  DARK_RED: '#8B0000',
  DEEP_KOAMARU: '#132C84',
  DISABLED_TEXT: '#999999',
  DISABLED: '#F2F2F2',
  DODGER_BLUE_2: '#1D7FFA',
  DODGER_BLUE_3: '#0ABBFF',
  DODGER_BLUE: '#2F77FF',
  DUSTY_GRAY: '#989898',
  EBONY_CLAY_1: '#222B32',
  EBONY_CLAY: '#222B32',
  ELECTRIC_PURPLE: '#a537fd',
  EMERALD: '#53ce5f',
  ENDEAVOUR: '#0567B4',
  ENERGY_YELLOW: '#F7D762',
  FADED_GREEN: '#e5fef8',
  FADED_YELLOW: '#fef8de',
  FLOWER_3: '#FCF0FF',
  FLOWER: '#DE5EE0',
  FOAM: '#EFF8FE',
  FRENCH_PASS: '#C0DCFE',
  FROSTED_MINT: '#E1FFF6',
  FUEL_YELLOW: '#EBB22F',
  FUNC_COLA: function FUNC_COLA(opacity) {
    return "rgba(0,0,0,".concat(opacity, ")");
  },
  GALAXY_BLUE: '#2A4B7C',
  GERALDINE: '#F18FF3',
  GHOST: '#E0E0E0',
  GOBLIN: '#3d8745',
  GOLDEN_DREAM: '#ECC820',
  GRAY_BACK_DROP: 'rgba(52, 58, 67, 0.8)',
  GREEN_HAZE: '#03aa64',
  GREEN: '#2AC3AA',
  GREY_SHADE: '#bebebe',
  GREY93: '#ededed',
  HAVELOCK_BLUE_1: '#4A90E2',
  HAVELOCK_BLUE: '#5397dc',
  HIGHLIGHT: '#D6EAF8',
  LIGHT_BLUE: '#EFF4FF',
  LIGHT_ORANGE: '#FFD992',
  LIGHT_WHITE: '#EFF8FF',
  LINK_WATER_LIGHT: '#F2F6FB',
  LINK_WATER: '#DAE4F2',
  LINK: '#1EB5F0',
  MANATEE: '#929295',
  MIDDLE_SATURATED_ORANGE: '#FFB100',
  MIDNIGHT: '#001935',
  MILANO_RED: '#c22400',
  MINE_SHAFT: '#222222',
  MUSTARD: '#ffcf56',
  PALE_GREEN: '#90EE90',
  PERIWINKLE_GRAY_DARK: 'rgba(187, 193, 227, 0.6)',
  PIG_PINK: '#FFE9DD',
  PRIMARY_GRADIENT_LIGHT: 'linear-gradient(142.6deg, #0177FF 0%, #0D2FA9 100%)',
  PRIMARY: '#0A47C2',
  PURPLE: '#850F85',
  RED_SHADE: '#C22300',
  RED: '#EA5959',
  SCIENCE_BLUE: '#1233B2',
  SCORPION: 'rgba(43, 43, 43, 0.75)',
  SECONDARY: '#0A80D5',
  SHARK: '#2A2A2E',
  SPACE_CADET: '#223250',
  STROM_GRAY: '#71778B',
  TEXT_LIGHT: toRGBA('#000000', 0.4),
  TEXT_SECONDARY: toRGBA('#000000', 0.6),
  TITAN_WHITE: '#E8ECFF',
  TORCH_RED: '#E34C67',
  TROPICAL_RAIN_FOREST: '#005E2C',
  VARDEN: '#FCF4E4',
  WHITE_TRANSPARENT: 'rgba(255, 255, 255, 0.8)',
  WHITE: '#FFFFFF'
};
var GRAYS = {
  GRAY: '#2B2B2B',
  GRAY_DARK: '#292734',
  GRAY_LIGHT: '#808080',
  GREY_SHADOW: 'rgba(0, 0, 0, 0.12)',
  GRAY_XLIGHT: '#B3B3B3',
  GRAY_XXLIGHT: '#E0E0E0',
  GRAY_XXXLIGHT: '#F6F6F6'
};
var SUN = {
  SUN_XXLIGHT: '#FCF4E4',
  SUN_XLIGHT: '#FFDC83',
  SUN_LIGHT: '#FFCF56',
  SUN: '#FFBA07',
  SUN_DARK: '#D68100',
  SUN_XDARK: '#995200',
  SUN_3: '#FFF7DB'
};
var SKY = {
  SKY_XXLIGHT: '#ECF8FF',
  SKY_XLIGHT: '#8DD5F1',
  SKY_LIGHT: '#52C8F5',
  SKY: '#1EB5F0',
  SKY_DARK: '#0A80D5',
  SKY_XDARK: '#0A47C2',
  SKY_BLUE: '#01a5f2'
};
var GRASS = {
  GRASS_XXLIGHT: '#DDFFE4',
  GRASS_XLIGHT: '#AFE8C2',
  GRASS_LIGHT: '#71DF96',
  GRASS: '#3DD771',
  GRASS_DARK: '#149A53',
  GRASS_XDARK: '#005E2C'
};
var FLOWER = {
  FLOWER_XXLIGHT: '#FDEAFA',
  FLOWER_XLIGHT: '#EBBDEC',
  FLOWER_LIGHT: '#F985F9',
  FLOWER: '#ED6CEF',
  FLOWER_DARK: '#B038B2',
  FLOWER_XDARK: '#850F85'
};
var ORANGE = {
  ORANGE_XXLIGHT: '#FFE9DD',
  ORANGE_XLIGHT: '#FFC2A2',
  ORANGE_LIGHT: '#FF9F6C',
  ORANGE_MEDIUM: '#ffba07',
  ORANGE: '#FF7E3B',
  ORANGE_DARK: '#DA5107',
  ORANGE_XDARK: '#9E2F00'
};
var HEART = {
  HEART_XXLIGHT: '#FFEDF2',
  HEART_XLIGHT: '#FFD4E4',
  HEART_LIGHT: '#FF98C3',
  HEART: '#FF6782',
  HEART_DARK: '#E34C67',
  HEART_XDARK: '#BF2449'
};
var ASH = {
  ASH_XXLIGHT: '#E6EBF2',
  ASH_XLIGHT: '#DAE4F2',
  ASH_LIGHT: '#B8C6D9',
  ASH: '#858DA6',
  ASH_DARK: '#71778B',
  ASH_XDARK: '#4D515F'
};
var BACKGROUNDS = {
  BG_MILK: '#FFFFFF',
  BG_CLOUD: '#F6F6F6',
  BG_GHOST: '#E0E0E0',
  BG_MODAL: toRGBA('#F6F6F6', 0.9),
  BG_MILK_LIGHT: toRGBA('#FFFFFF', 0.3)
};

var COLORS = _objectSpread({}, COLORS_MAP, {
  TEXT_REGULAR: GRAYS.GRAY,
  TEXT_LIGHT: toRGBA(GRAYS.GRAY, 0.75),
  TEXT_LIGHTER: GRAYS.GRAY_XLIGHT,
  BORDER: COLORS_MAP.TITAN_WHITE,
  SUB_TEXT: toRGBA(COLORS_MAP.WHITE, 0.7),
  OVERLAY: toRGBA(COLORS_MAP.MINE_SHAFT, 0.8),
  DARK_OVERLAY: 'rgba(28,43,60,0.95)',
  BG_CLOUD_LIGHT: toRGBA(BACKGROUNDS.BG_CLOUD, 0.8)
}, GRAYS, SUN, SKY, GRASS, FLOWER, ORANGE, HEART, ASH, BACKGROUNDS);

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mapSandboxToString = function mapSandboxToString() {
  var sandbox = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var sandboxDetails = _objectSpread({}, sandbox);

  if (typeof sandbox === 'string') {
    return sandbox;
  }

  return Object.keys(sandboxDetails).filter(function (key) {
    return sandboxDetails[key];
  }).map(function (s) {
    return s.replace(/[A-Z]/g, '-$&').toLowerCase();
  }).join(' ');
};

var Iframe = /*#__PURE__*/function (_PureComponent) {
  _inherits(Iframe, _PureComponent);

  var _super = _createSuper$b(Iframe);

  function Iframe() {
    _classCallCheck(this, Iframe);

    return _super.apply(this, arguments);
  }

  _createClass(Iframe, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          onLoad = _this$props.onLoad,
          onBeforeUnload = _this$props.onBeforeUnload,
          onUnload = _this$props.onUnload,
          title = _this$props.title,
          src = _this$props.src,
          props = _objectWithoutProperties(_this$props, ["style", "onLoad", "onBeforeUnload", "onUnload", "title", "src"]);

      if (props.sandbox === false) {
        delete props.sandbox;
      } else if (typeof props.sandbox === 'object') {
        props.sandbox = mapSandboxToString(props.sandbox);
      }

      return /*#__PURE__*/React.createElement("iframe", Object.assign({
        title: title
      }, props, {
        src: src,
        style: _objectSpread({
          borderWidth: 0
        }, style),
        onLoad: onLoad
      }));
    }
  }]);

  return Iframe;
}(PureComponent);

Iframe.defaultProps = {
  width: '100%',
  height: '100%',
  sandbox: {
    allowForms: true,
    allowModals: true,
    allowPointerLock: false,
    allowPopups: true,
    allowSameOrigin: true,
    allowScripts: true,
    allowTopNavigation: false
  },
  style: {},
  onLoad: function onLoad() {},
  onBeforeUnload: function onBeforeUnload() {},
  onUnload: function onUnload() {},
  title: 'Iframe'
};

var _templateObject$c, _templateObject2$9, _templateObject3$6, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$2, _templateObject8$2, _templateObject9$2;

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getWrapperStyle(_ref) {
  var size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      radius = _ref.radius;

  if (size === 'full-screen') {
    return css(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n      width: 100%;\n      height: 100%;\n      max-height: 100%;\n    "])));
  }

  if (size === 'custom') {
    return css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n      max-height: ", ";\n      border-radius: ", ";\n    "])), width, height, height, radius || '8px');
  }

  return css(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n    width: 420px;\n    min-height: 56px;\n    max-height: calc(100vh - 60px);\n    border-radius: 8px;\n  "])));
}

var Wrapper$2 = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n  overflow: ", ";\n  ", ";\n"])), function (props) {
  return getWrapperStyle(props);
}, function (_ref2) {
  var overflow = _ref2.overflow;
  return overflow;
}, function (_ref3) {
  var transparent = _ref3.transparent,
      bg = _ref3.bg;
  return !transparent && css(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n      background: ", ";\n      box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.4);\n    "])), bg || COLORS.WHITE);
});
var CloseButtonWrapper = styled.div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n  padding: 12px;\n  cursor: pointer;\n"])), function (_ref4) {
  var top = _ref4.top;
  return top || 0;
}, function (_ref5) {
  var right = _ref5.right;
  return right || 0;
});
var CloseIcon = styled(Close)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), COLORS.GRAY);
var HangingCloseIcon = styled(Close)(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n  color: white;\n  right: 0;\n  position: absolute;\n  top: 0;\n"])));
var HangingCloseIconWrapper = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 16px 36px;\n"])));

var Modal = /*#__PURE__*/function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  var _super = _createSuper$c(Modal);

  function Modal() {
    _classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  _createClass(Modal, [{
    key: "renderModal",
    value: function renderModal() {
      var _this$props = this.props,
          Comp = _this$props.Comp,
          props = _this$props.props,
          bg = _this$props.bg,
          blocking = _this$props.blocking,
          transparent = _this$props.transparent,
          size = _this$props.size,
          outSideCloseButton = _this$props.outSideCloseButton,
          onClose = _this$props.onClose,
          other = _objectWithoutProperties(_this$props, ["Comp", "props", "bg", "blocking", "transparent", "size", "outSideCloseButton", "onClose"]);

      return /*#__PURE__*/React.createElement(Wrapper$2, Object.assign({
        className: "wrapper",
        size: size,
        bg: bg,
        transparent: transparent
      }, other), /*#__PURE__*/React.createElement(Comp, Object.assign({
        transparent: transparent
      }, props, {
        closeModal: onClose
      })), !blocking && !outSideCloseButton ? /*#__PURE__*/React.createElement(CloseButtonWrapper, {
        onClick: onClose
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        size: 18
      })) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          outSideCloseButton = _this$props2.outSideCloseButton,
          onClose = _this$props2.onClose,
          top = _this$props2.top,
          right = _this$props2.right;
      return outSideCloseButton ? /*#__PURE__*/React.createElement(HangingCloseIconWrapper, null, /*#__PURE__*/React.createElement(CloseButtonWrapper, {
        onClick: onClose,
        top: top,
        right: right
      }, /*#__PURE__*/React.createElement(HangingCloseIcon, {
        size: 32
      })), this.renderModal()) : this.renderModal();
    }
  }]);

  return Modal;
}(PureComponent);

Modal.defaultProps = {
  bg: COLORS.WHITE,
  transparent: false,
  overflow: 'auto',
  blocking: false,
  size: 'normal',
  outSideCloseButton: false,
  top: 0,
  right: 0
};

var _templateObject$d, _templateObject2$a, _templateObject3$7, _templateObject4$5;

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TIMEOUT = {
  enter: 0,
  exit: 400
};
var ENTERED = 'entered';
var BackDrop = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(1, 35, 74, 0.75);\n  z-index: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in;\n  pointer-events: ", ";\n  ", ";\n"])), function (_ref) {
  var _ref$theme$ZINDEX = _ref.theme.ZINDEX,
      EVENT_TRIGGERED_MODAL = _ref$theme$ZINDEX.EVENT_TRIGGERED_MODAL,
      MODAL = _ref$theme$ZINDEX.MODAL,
      isEventTriggered = _ref.isEventTriggered;
  return isEventTriggered ? EVENT_TRIGGERED_MODAL : MODAL;
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 1 : 0;
}, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 'all' : 'none';
}, function (_ref4) {
  var backdropFilter = _ref4.backdropFilter;
  return backdropFilter && css(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n      @supports (backdrop-filter: blur(10px)) or (-webkit-backdrop-filter: blur(10px)) {\n        background-color: rgba(0, 0, 0, 0.3);\n        backdrop-filter: blur(10px);\n        --webkit-backdrop-filter: blur(10px);\n      }\n    "])));
});
var ScaleWrapper = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: calc(100vh);\n  ", "\n  transition: transform 0.3s ease-in;\n"])), function (_ref5) {
  var enableTransform = _ref5.enableTransform;
  return enableTransform && css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n      transform: scale(", ");\n    "])), function (_ref6) {
    var visible = _ref6.visible;
    return visible ? 1 : 0;
  });
});

var ModalProvider = /*#__PURE__*/function (_PureComponent) {
  _inherits(ModalProvider, _PureComponent);

  var _super = _createSuper$d(ModalProvider);

  function ModalProvider() {
    var _this;

    _classCallCheck(this, ModalProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onBackdropClick = function (e) {
      if (e.target === e.currentTarget) {
        var _this$props = _this.props,
            modal = _this$props.modal,
            onClose = _this$props.onClose;

        if (modal.options && modal.options.blocking) {
          return;
        }

        onClose();
      }
    };

    return _this;
  }

  _createClass(ModalProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          modal = _this$props2.modal,
          scrollDisableClass = _this$props2.scrollDisableClass;

      if (modal && !prevProps.modal) {
        document.body.classList.add(scrollDisableClass);
      } else if (!modal && prevProps.modal) {
        document.body.classList.remove(scrollDisableClass);
      }
    }
  }, {
    key: "renderModal",
    value: function renderModal(_ref7) {
      var name = _ref7.name,
          options = _ref7.options,
          props = _ref7.props;
      var _this$props3 = this.props,
          modals = _this$props3.modals,
          onClose = _this$props3.onClose;
      var Comp = modals[name];
      return Comp ? /*#__PURE__*/React.createElement(Modal, Object.assign({
        key: name,
        Comp: Comp,
        props: props,
        onClose: onClose
      }, options)) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          modal = _this$props4.modal,
          isEventTriggered = _this$props4.isEventTriggered;

      var _ref8 = modal || {},
          _ref8$options = _ref8.options;

      _ref8$options = _ref8$options === void 0 ? {} : _ref8$options;
      var backdropFilter = _ref8$options.backdropFilter,
          _ref8$options$enableT = _ref8$options.enableTransform,
          enableTransform = _ref8$options$enableT === void 0 ? true : _ref8$options$enableT;
      return /*#__PURE__*/React.createElement(TransitionGroup, null, modal && /*#__PURE__*/React.createElement(Transition, {
        key: modal.name,
        modal: modal,
        timeout: TIMEOUT
      }, function (state, childProps) {
        return /*#__PURE__*/React.createElement(BackDrop, {
          isEventTriggered: isEventTriggered,
          visible: state === ENTERED,
          backdropFilter: backdropFilter
        }, /*#__PURE__*/React.createElement(ScaleWrapper, {
          enableTransform: enableTransform,
          visible: state === ENTERED,
          onClick: _this2.onBackdropClick
        }, /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement(Text, null, "Loading...")
        }, _this2.renderModal(childProps.modal))));
      }));
    }
  }]);

  return ModalProvider;
}(PureComponent);

ModalProvider.defaultProps = {
  modal: null,
  scrollDisableClass: 'disable-scroll',
  isEventTriggered: false
};

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Module = /*#__PURE__*/function (_PureComponent) {
  _inherits(Module, _PureComponent);

  var _super = _createSuper$e(Module);

  function Module() {
    _classCallCheck(this, Module);

    return _super.apply(this, arguments);
  }

  _createClass(Module, [{
    key: "renderModule",
    value: function renderModule() {
      var _this$props = this.props,
          visible = _this$props.visible,
          Component = _this$props.module,
          other = _objectWithoutProperties(_this$props, ["visible", "module"]);

      return /*#__PURE__*/React.createElement(Component, other);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          Loader = _this$props2.loadingComponent;

      if (!visible) {
        if (Loader) {
          return /*#__PURE__*/React.createElement(Loader, null);
        }

        return /*#__PURE__*/React.createElement(Text, {
          align: "center"
        }, "Loading...");
      }

      return this.renderModule();
    }
  }]);

  return Module;
}(PureComponent);

Module.defaultProps = {
  loadingComponent: null
};

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModuleContainer = /*#__PURE__*/function (_PureComponent) {
  _inherits(ModuleContainer, _PureComponent);

  var _super = _createSuper$f(ModuleContainer);

  function ModuleContainer(props) {
    var _this;

    _classCallCheck(this, ModuleContainer);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        cache = _this$props.cache,
        _this$props$resource = _this$props.resource,
        isLoaded = _this$props$resource.isLoaded,
        isStale = _this$props$resource.isStale;
    _this.state = {
      loadedOnce: cache ? isLoaded || isStale || false : false,
      failedOnce: false,
      // eslint-disable-line react/no-unused-state
      cache: cache // eslint-disable-line react/no-unused-state

    };
    return _this;
  }

  _createClass(ModuleContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          resource = _this$props2.resource,
          other = _objectWithoutProperties(_this$props2, ["resource"]);

      var loadedOnce = this.state.loadedOnce;
      return /*#__PURE__*/React.createElement(Module, Object.assign({
        visible: loadedOnce
      }, other));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _props$resource = props.resource,
          isLoaded = _props$resource.isLoaded,
          isLoading = _props$resource.isLoading,
          isLoadingFailed = _props$resource.isLoadingFailed,
          isStale = _props$resource.isStale;
      var loadedOnce = state.loadedOnce,
          cache = state.cache;

      if (!loadedOnce && cache && (isLoaded || isStale)) {
        return {
          loadedOnce: true,
          failedOnce: false
        };
      }

      if (!loadedOnce && !cache && isLoading) {
        return {
          cache: true
        };
      }

      if (isLoaded) {
        return {
          failedOnce: false
        };
      }

      if (isLoadingFailed) {
        return {
          failedOnce: true
        };
      }

      return null;
    }
  }]);

  return ModuleContainer;
}(PureComponent);

ModuleContainer.defaultProps = {
  cache: false
};

var _templateObject$e, _templateObject2$b, _templateObject3$8, _templateObject4$6, _templateObject5$4;

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CtaWrapper = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  color: #ffffff;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding-top: ", ";\n"])), function (_ref) {
  var ctaList = _ref.ctaList;
  return ctaList && ctaList.length > 0 ? '15px' : '0px';
});
var CloseBtnWrapper = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 5px;\n  cursor: pointer;\n"])));
var CloseIcon$1 = styled(Close)(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  color: #ffffff;\n"])));
var ToastWrapper = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  display: flex;\n  position: fixed;\n  width: 300px;\n  min-height: 100px;\n  top: 80px;\n  right: 20px;\n  padding: 12px;\n  padding-right: ", ";\n  background: ", ";\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  border-radius: 4px;\n  z-index: 17;\n  transform: translateX(350px);\n  transition: all 300ms ease-in-out;\n"])), function (_ref2) {
  var ctaList = _ref2.ctaList;
  return ctaList && ctaList.length > 0 ? '0px' : '12px';
}, toRGBA(COLORS.BLACK, 0.8));
var CTDiv = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n  align-self: center;\n  width: 100%;\n"])));
var transitionStyles = {
  entering: {
    transform: 'translateX(0)'
  },
  entered: {
    transform: 'translateX(0)',
    transition: 'all 300ms ease-in-out'
  },
  exiting: {
    transform: 'translateX(350px)'
  },
  exited: {
    transform: 'translateX(350px)'
  }
};

var NotificationToast = /*#__PURE__*/function (_PureComponent) {
  _inherits(NotificationToast, _PureComponent);

  var _super = _createSuper$g(NotificationToast);

  function NotificationToast(props) {
    var _this;

    _classCallCheck(this, NotificationToast);

    _this = _super.call(this, props);

    _this.componentWillReceiveProps = function (nextProps) {
      _this.setState({
        inProp: !!nextProps.message
      });
    };

    _this.componentDidUpdate = function () {
      var _this$props = _this.props,
          message = _this$props.message,
          ctaList = _this$props.ctaList;
      var isDismissible = !(ctaList !== null && ctaList.length > 0);

      if (message && isDismissible) {
        _this.startHideTimer();
      }

      if (!isDismissible) {
        _this.clearTimer();
      }
    };

    _this.hideToastTrigger = function () {
      var hideToast = _this.props.hideToast;
      hideToast();

      _this.clearTimer();
    };

    _this.ctaClick = function (ctaCallback) {
      ctaCallback();

      _this.hideToastTrigger();
    };

    _this.startHideTimer = function () {
      var timeout = _this.props.timeout;
      _this.timer = setTimeout(function () {
        _this.hideToastTrigger();
      }, timeout);
    };

    _this.clearTimer = function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    };

    _this.renderCtaList = function () {
      var ctaList = _this.props.ctaList;

      if (ctaList) {
        return ctaList.map(function (_ref3) {
          var text = _ref3.text,
              _onClick = _ref3.onClick;
          return /*#__PURE__*/React.createElement(Button, {
            key: text,
            label: text,
            renderAs: "link-inverted",
            underline: true,
            onClick: function onClick() {
              return _this.ctaClick(_onClick);
            },
            justify: "center"
          });
        });
      }

      return null;
    };

    _this.state = {
      inProp: !!props.message
    };
    return _this;
  }

  _createClass(NotificationToast, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          message = _this$props2.message,
          ctaList = _this$props2.ctaList;
      var inProp = this.state.inProp;
      var isDismissible = !(ctaList !== null && ctaList.length > 0);
      var duration = 1000;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Transition, {
        in: inProp,
        timeout: duration
      }, function (state) {
        return /*#__PURE__*/React.createElement(ToastWrapper, {
          style: _objectSpread({}, transitionStyles[state]),
          ctaList: ctaList
        }, isDismissible && /*#__PURE__*/React.createElement(CloseBtnWrapper, {
          onClick: _this2.hideToastTrigger
        }, /*#__PURE__*/React.createElement(CloseIcon$1, {
          size: 15
        })), /*#__PURE__*/React.createElement(CTDiv, null, /*#__PURE__*/React.createElement(Text, {
          size: "medium",
          type: "white",
          align: "left"
        }, message), /*#__PURE__*/React.createElement(CtaWrapper, {
          ctaList: ctaList
        }, _this2.renderCtaList())));
      }));
    }
  }]);

  return NotificationToast;
}(PureComponent);

NotificationToast.defaultProps = {
  message: null,
  timeout: 2000,
  ctaList: null
};

var _templateObject$f, _templateObject2$c;
var rotate$1 = keyframes(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var CircleNotchIcon = styled(CircleNotch)(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  color: ", ";\n  animation: ", " 1.5s ease-in-out infinite;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
}, rotate$1);

function SpinnerComp(_ref2) {
  var size = _ref2.size,
      color = _ref2.color;
  return /*#__PURE__*/React.createElement(FlexView, {
    justifyContent: "center",
    alignItems: "center",
    inherit: true
  }, /*#__PURE__*/React.createElement(CircleNotchIcon, {
    size: size,
    color: color
  }));
}

SpinnerComp.defaultProps = {
  color: '#FFFFFF'
};
var index = memo(SpinnerComp);

var _templateObject$g, _templateObject2$d, _templateObject3$9, _templateObject4$7, _templateObject5$5, _templateObject6$4, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject10$2, _templateObject11$2, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var moveten$1 = keyframes(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  0% {\n    top: 0;\n  }\n  100% {\n    top: -220px;\n  }\n"])));
var movesix$1 = keyframes(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  0% {\n    top: 0;\n  }\n  100% {\n    top: -132px;\n  }\n"])));
var Container = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Wrapper$3 = styled.div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 22px;\n  width: 9px;\n  overflow: hidden;\n"])));
var Sec1$1 = styled.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  ", "\n"])), function (_ref) {
  var paused = _ref.paused,
      delay = _ref.delay;
  return !paused && css(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n      animation: ", " 60s steps(6, end) infinite;\n      animation-delay: -", "s;\n    "])), movesix$1, delay);
});
var Sec2$1 = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  ", ";\n"])), function (_ref2) {
  var paused = _ref2.paused;
  return !paused && css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n      animation: ", " 10s steps(10, end) infinite;\n    "])), moveten$1);
});
var Min1$1 = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  ", ";\n"])), function (_ref3) {
  var paused = _ref3.paused,
      delay = _ref3.delay;
  return !paused && css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n      animation: ", " 3600s steps(6, end) infinite;\n      animation-delay: -", "s;\n    "])), movesix$1, delay);
});
var Min2$1 = styled.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  ", ";\n"])), function (_ref4) {
  var paused = _ref4.paused,
      delay = _ref4.delay;
  return !paused && css(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n      animation: ", " 600s steps(10, end) infinite;\n      animation-delay: -", "s;\n    "])), moveten$1, delay);
});
var Hour2$1 = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  ", ";\n"])), function (_ref5) {
  var paused = _ref5.paused,
      delay = _ref5.delay;
  return !paused && css(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n      animation: ", " 36000s steps(10, end) infinite;\n      animation-delay: -", "s;\n    "])), moveten$1, delay);
});
var Hour1$1 = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  ", ";\n"])), function (_ref6) {
  var paused = _ref6.paused,
      delay = _ref6.delay;
  return !paused && css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      animation: ", " 360000s steps(10, end) infinite;\n      animation-delay: -", "s;\n    "])), moveten$1, delay);
});
var SplitText$1 = styled(Text)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  line-height: 18px;\n"])));
var TimerText = styled(Text)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  line-height: 22px;\n"])));
var TENS$1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
var SIXES$1 = [0, 1, 2, 3, 4, 5];

var Timer = /*#__PURE__*/function (_PureComponent) {
  _inherits(Timer, _PureComponent);

  var _super = _createSuper$h(Timer);

  function Timer() {
    var _this;

    _classCallCheck(this, Timer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      timerCompleted: false
    };
    return _this;
  }

  _createClass(Timer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          time = _this$props.time,
          onComplete = _this$props.onComplete;
      this.timer = setTimeout(function () {
        _this2.setState({
          timerCompleted: true
        }, onComplete);
      }, time * 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          color = _this$props2.color,
          time = _this$props2.time;
      var timerCompleted = this.state.timerCompleted;

      var _Timer$getDigits = Timer.getDigits(timerCompleted ? 0 : time),
          _Timer$getDigits2 = _slicedToArray(_Timer$getDigits, 6),
          H1 = _Timer$getDigits2[0],
          H2 = _Timer$getDigits2[1],
          M1 = _Timer$getDigits2[2],
          M2 = _Timer$getDigits2[3],
          S1 = _Timer$getDigits2[4],
          S2 = _Timer$getDigits2[5];

      var SEC2 = [].concat(_toConsumableArray(TENS$1.slice(S2 + 1)), _toConsumableArray(TENS$1.slice(0, S2 + 1))).reverse();
      var SEC1 = [].concat(_toConsumableArray(SIXES$1.slice(S1 + 1)), _toConsumableArray(SIXES$1.slice(0, S1 + 1))).reverse();
      var MIN2 = [].concat(_toConsumableArray(TENS$1.slice(M2 + 1)), _toConsumableArray(TENS$1.slice(0, M2 + 1))).reverse();
      var MIN1 = [].concat(_toConsumableArray(SIXES$1.slice(M1 + 1)), _toConsumableArray(SIXES$1.slice(0, M1 + 1))).reverse();
      var HOUR2 = [].concat(_toConsumableArray(TENS$1.slice(H2 + 1)), _toConsumableArray(TENS$1.slice(0, H2 + 1))).reverse();
      var HOUR1 = [].concat(_toConsumableArray(TENS$1.slice(H1 + 1)), _toConsumableArray(TENS$1.slice(0, H1 + 1))).reverse();
      var delayS1 = 9 - S2;
      var delayM2 = 59 - "".concat(S1).concat(S2);
      var delayM1 = 599 - M2 * 60 - "".concat(S1).concat(S2);
      var delayH2 = 3599 - "".concat(M1).concat(M2) * 60 - "".concat(S1).concat(S2);
      var delayH1 = 35999 - "".concat(H2) * 60 * 60 - "".concat(M1).concat(M2) * 60 - "".concat(S1).concat(S2);
      return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Hour1$1, {
        delay: delayH1,
        paused: timerCompleted
      }, HOUR1.map(function (v) {
        return /*#__PURE__*/React.createElement(TimerText, {
          color: color,
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Hour2$1, {
        delay: delayH2,
        paused: timerCompleted
      }, HOUR2.map(function (v) {
        return /*#__PURE__*/React.createElement(TimerText, {
          color: color,
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(SplitText$1, {
        color: color,
        align: "center",
        weight: "bold"
      }, ":")), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Min1$1, {
        delay: delayM1,
        paused: timerCompleted
      }, MIN1.map(function (v) {
        return /*#__PURE__*/React.createElement(TimerText, {
          color: color,
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Min2$1, {
        delay: delayM2,
        paused: timerCompleted
      }, MIN2.map(function (v) {
        return /*#__PURE__*/React.createElement(TimerText, {
          color: color,
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(SplitText$1, {
        color: color,
        align: "center",
        weight: "bold"
      }, ":")), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Sec1$1, {
        delay: delayS1,
        paused: timerCompleted
      }, SEC1.map(function (v) {
        return /*#__PURE__*/React.createElement(TimerText, {
          color: color,
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))), /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(Sec2$1, {
        paused: timerCompleted
      }, SEC2.map(function (v) {
        return /*#__PURE__*/React.createElement(TimerText, {
          color: color,
          align: "center",
          weight: "bold",
          key: v
        }, v);
      }))));
    }
  }], [{
    key: "getDigits",
    value: function getDigits(time) {
      if (time < 0) {
        return [0, 0, 0, 0, 0, 0];
      }

      var hours = Math.trunc(time / 3600);
      var minutes = Math.trunc(time / 60);
      var seconds = Math.trunc(time % 60);
      return [Math.trunc(hours / 10), Math.trunc(hours % 10), Math.trunc(minutes % 60 / 10), Math.trunc(minutes % 60 % 10), Math.trunc(seconds / 10), Math.trunc(seconds % 10)];
    }
  }]);

  return Timer;
}(PureComponent);

Timer.defaultProps = {
  color: '#000000',
  onComplete: function onComplete() {}
};

var _templateObject$h, _templateObject2$e;
var Tooltip = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"])));
var TooltipText = styled.span(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  visibility: hidden;\n  width: 60px;\n  background-color: rgb(36, 188, 252);\n  color: #fff;\n  text-align: center;\n  border-radius: 3px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  top: 120%;\n  left: 50%;\n  margin-left: -33px;\n  font-size: 12px;\n  box-shadow: 5px 5px 5px rgba(29, 66, 186, 0.5);\n  opacity: 0;\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent rgb(36, 188, 252) transparent;\n  }\n  ", ":hover & {\n    visibility: visible;\n    opacity: 1;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n"])), Tooltip);

export { Clock, COLORS, toRGBA, Iframe, ModalProvider as Modal, ModuleContainer as Module, NotificationToast, Separator, index as Spinner, Text, Timer, Tooltip, TooltipText, FONT, Button, TextInput, PasswordInput, CheckBoxGroup as CheckboxGroup, FlexView, Col$1 as Col, Row$1 as Row, Card, List, SectionList, ProgressBarHorizontal, ProgressBarRadial, ProgressBarGauge };
//# sourceMappingURL=bundle.js.map
